import { Form, Formik } from 'formik';
import USER_TYPE from 'gcs-common/helper/userTypeHelper';
import { stringValidator } from 'gcs-common/helper/yupValidationHelper';
import {
  getAddUserToSelectedTeamDefaultErrorMessage,
  getAddUserToSelectedTeamErrorMessage,
} from 'gcs-common/slices/administration/teams/teamsSelectors';
import {
  resetAddUserToSelectedTeamDefaultErrorMessage,
  resetAddUserToSelectedTeamErrorMessage,
} from 'gcs-common/slices/administration/teams/teamsSlice';
import { addUserToSelectedTeam } from 'gcs-common/slices/administration/teams/teamsThunks';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import TeamPropType from '../../../../models/TeamPropType';
import { showFailureNotification } from '../../../../slices/notifications/ShowNotificationThunk';
import Button from '../../../Button/Button';
import FormikUserSelect from '../../shared/FormikUserSelect/FormikUserSelect';
import styles from './styles.module.scss';

export const TeamAddUserValidationSchema = Yup.object().shape({
  userId: stringValidator,
});

const TeamAddUser = ({ team, onCancel, onSuccess }) => {
  const { id: teamId } = team;

  const dispatch = useDispatch();
  const errorMessage = useSelector(getAddUserToSelectedTeamErrorMessage);
  const defaultErrorMessage = useSelector(getAddUserToSelectedTeamDefaultErrorMessage);

  useEffect(() => {
    dispatch(resetAddUserToSelectedTeamDefaultErrorMessage());
    dispatch(resetAddUserToSelectedTeamErrorMessage());
  }, [dispatch]);

  useEffect(() => {
    if (defaultErrorMessage) {
      dispatch(showFailureNotification(defaultErrorMessage, dispatch(resetAddUserToSelectedTeamDefaultErrorMessage())));
    }
  }, [defaultErrorMessage, dispatch]);

  const resetErrorOnChange = useCallback(() => {
    if (errorMessage) {
      dispatch(resetAddUserToSelectedTeamErrorMessage());
    }
  }, [dispatch, errorMessage]);

  const submit = useCallback(
    async ({ userId }, { setSubmitting }) => {
      const result = await dispatch(addUserToSelectedTeam({ teamId, userId }));
      setSubmitting(false);
      if (!result.error) {
        onSuccess(true);
      }
    },
    [dispatch, teamId, onSuccess],
  );

  return (
    <Formik initialValues={{ userId: '' }} validationSchema={TeamAddUserValidationSchema} onSubmit={submit}>
      {({ isSubmitting }) => (
        <Form className={styles.column}>
          <div className={styles.row}>
            <FormikUserSelect
              userType={USER_TYPE.AGENT}
              selectKey="teamAddUserAgentSelection"
              label="Mitarbeiter*"
              name="userId"
              labelKey="friendlyName"
              valueKey="id"
              onChange={resetErrorOnChange}
            />
          </div>
          {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
          <div className={styles.buttonRow}>
            <Button className={styles.modalButtonSecondary} type="button" disabled={isSubmitting} onClick={onCancel}>
              Abbrechen
            </Button>
            <Button className={styles.modalButton} type="submit" disabled={isSubmitting}>
              Speichern
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

TeamAddUser.propTypes = {
  team: TeamPropType.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default TeamAddUser;
